var cilArrowThickToTop = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M56,297.365V336H176V496H336V336H456V297.374l-199.8-200ZM304,304V464H208V304H94.639l161.535-161.37L417.384,304Z' class='ci-primary'/><rect width='400' height='32' x='56' y='16.002' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilArrowThickToTop };

